export default "__VITE_ASSET__Bdr0lkYV__"